/**
 * @param {Function} func any function
 * @param {Array} args array of args for func
 *
 * @returns {Object} func,args object
 */
export default (func, args = []) => ({ func, args });
